<template>
  <div>
    <el-row>
    <el-col :span="22">
      <el-input v-model="inputFile" type="file" placeholder="Please input" size="small"/>
      <!--      <el-input v-model="input" type="file" placeholder="Please input" size="small" webkitdirectory/>-->
    </el-col>
    <!--    <el-col :span="2">-->
    <!--      <el-upload-->
    <!--          class="upload-demo"-->
    <!--          :show-file-list="false"-->
    <!--          :on-change="onChanged"-->
    <!--          :auto-upload="false"-->
    <!--      >-->
    <!--        <el-button size="small" type="primary">选择..</el-button>-->
    <!--      </el-upload>-->
    <!--    </el-col>-->
    <el-col :span="2" style="text-align: center">
      <!--      <el-button size="small" type="primary" :onclick="uploadFile">上传</el-button>-->
      <el-button size="small" type="primary" @click="fileInfoDlgVisible = true">上传</el-button>
    </el-col>
  </el-row>
    <div v-dialogDrag>
      <el-dialog v-model="fileInfoDlgVisible" title="资料上传" :before-close="handleClose" destroy-on-close
                 width="500px">
        <template #default>
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="区块：">
              <el-cascader
                  v-model="form.qk"
                  placeholder="东河1"
                  :options="qkSelOptions"
                  :show-all-levels="false"
                  @change="qkSelChange"
                  filterable
              />
            </el-form-item>
            <el-form-item label="类型：">
              <el-cascader
                  v-model="form.lx"
                  placeholder="综合治理方案"
                  :options="wdlxSelOptions"
                  filterable
              />
            </el-form-item>
            <el-form-item label="提交人：">
              <el-input v-model="form.tjr" placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="提交时间：">
              <el-date-picker
                  v-model="form.tjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="创建人：">
              <el-input v-model="form.cjr" placeholder="Boris" style="width: 220px"/>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-date-picker
                  v-model="form.cjsj"
                  type="datetime"
                  placeholder="Select date and time"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="保密级别：">
              <el-radio v-model="form.radio1" label="1">低</el-radio>
              <el-radio v-model="form.radio1" label="2">中</el-radio>
              <el-radio v-model="form.radio1" label="3">高</el-radio>
            </el-form-item>
            <el-form-item label="关联井号：">
              <el-select v-model="form.value" filterable clearable multiple placeholder="Select">
                <el-option
                    v-for="item in welldata"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="fileInfoDlgVisible = false">取消</el-button>
            <el-button type="primary" @click="uploadFile"
            >确定
            </el-button
            >
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessageBox} from "element-plus";
import {v4 as uuidv4} from "uuid";
import {hex_md5} from '../../public/static/js/md5.js'
import {_10to62} from '../../public/static/js/util.js'
// let m_file;

export default {
  name: "tjFileUploader",
  mounted: function () {
    this.fetchQKData();
    this.fetchWDLXData();
  },
  methods: {
    uploadFile() {
      let _this = this;
      let file = document.querySelector('input[type=file]').files[0];
      let key = hex_md5(file.name + file.size + file.type + file.lastModified);
      let key10 = parseInt(key, 16);
      let key62 = _10to62(key10);

      let suffixs = _this.suffixs;
      let fileName = file.name;
      let suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase();
      let validateSuffix = false;
      for (let i = 0; i < suffixs.length; i++) {
        if (suffixs[i].toLowerCase() === suffix) {
          validateSuffix = true;
          break;
        }
      }
      if (!validateSuffix) {
        // alert("文件格式不正确！只支持上传：" + suffixs.join(","));
        // // $("#" + _this.inputId + "-input").val("");
        // _this.inputFile = "";
        // return;
      }
      // 文件分片
      // let shardSize = 10 * 1024 * 1024;    //以10MB为一个分片
      // let shardSize = 50 * 1024;    //以50KB为一个分片
      let shardSize = _this.shardSize;
      let shardIndex = 1;		//分片索引，1表示第1个分片
      let size = file.size;
      let shardTotal = Math.ceil(size / shardSize); //总片数
      let scLogId = uuidv4();
      scLogId = scLogId.replace("-", "");
      console.log("form",_this.form);
      let param = {
        'shardIndex': shardIndex,
        'shardSize': shardSize,
        'shardTotal': shardTotal,
        'use': _this.use,
        'tjName': file.name,
        'tjSuffix': suffix,
        'tjSize': file.size,
        'tjKey': key62,
        'flId': _this.form.lx.length>0?_this.form.lx[_this.form.lx.length-1]:'',
        'cjr': _this.form.cjr,
        'tjr': _this.form.tjr,
        'bmjb':_this.form.radio1,
        'remark': '无',
        'cjsj': _this.form.cjsj,
        'tjsj': _this.form.tjsj,
        'scLogId': scLogId,
        'assocWells':_this.form.value
      };
      console.log(param);
      _this.check(param);
    },
    check(param) {
      let _this = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/fileprocesser/check?key=" + param.tjKey + "&use=" + param.use,
        method: 'GET'
      }).then((res) => {
        let resp = res.data;
        if (resp.success) {
          let obj = resp.content;
          console.log(resp);
          console.log(obj);
          if (!obj) {
            param.shardIndex = 1;
            console.log("没有找到文件记录，从分片1开始上传");
            _this.upload(param);
          } else if (obj.shardIndex === obj.shardTotal) {
            // 已上传分片 = 分片总数，说明已全部上传完，不需要再上传
            // alert("文件极速秒传成功！");
            _this.fileInfoDlgVisible = false
            ElMessageBox("文件极速秒传成功！");
            // _this.afterUpload(resp);
            _this.uploadWithoutFile(param);
            _this.inputFile = "";
          } else {
            param.shardIndex = obj.shardIndex + 1;
            console.log("找到文件记录，从分片" + param.shardIndex + "开始上传");
            _this.upload(param);
          }
          console.log(res);
        } else {
          ElMessageBox("文件上传失败");
          _this.inputFile = "";
        }
        // _this.loading = false;
      }).catch((err) => {
        ElMessageBox("文件上传失败");
        _this.inputFile = "";
        console.log(err)
        // _this.loading = false;
      })
    },
    /**
     * 将分片数据转成base64进行上传
     */
    upload(param) {
      let _this = this;
      let shardIndex = param.shardIndex;
      let shardTotal = param.shardTotal;
      let shardSize = param.shardSize;
      let fileShard = _this.getFileShard(shardIndex, shardSize);
      let fileReader = new FileReader();

      // _this.loading = true;
      fileReader.onload = function (e) {
        let base64 = e.target.result;
        console.log("base64:", base64);

        param.file_Base64 = base64;
        console.log(param);
        axios({
          url: _this.uploadUrl,
          method: 'POST',
          data: param
        }).then((res) => {
          if (res.status === 200) {
            let resp = res.data;
            console.log("上传文件成功：", resp);
            if (shardIndex < shardTotal) {
              // 上传下一个分片
              param.shardIndex = param.shardIndex + 1;
              _this.upload(param);
            } else {
              // _this.afterUpload(resp);
              _this.uploadLog(param.scLogId, _this.form.qk.length>0?_this.form.qk[_this.form.qk.length-1]:'', param.use)
              _this.fileInfoDlgVisible = false
              _this.afterUpload(resp);
              ElMessageBox('文件上传成功');
              _this.inputFile = "";
            }
          }
          // _this.loading = false;
        }).catch((err) => {
          ElMessageBox('Error');
          console.log(err)
          // _this.loading = false;
        })
      };

      fileReader.readAsDataURL(fileShard);
    },
    getFileShard(shardIndex, shardSize) {
      let file = document.querySelector('input[type=file]').files[0];
      console.log("file:", file);
      let start = (shardIndex - 1) * shardSize;	//当前分片起始位置
      let end = Math.min(file.size, start + shardSize); //当前分片结束位置
      let fileShard = file.slice(start, end); //从文件中截取当前的分片数据
      return fileShard;
    },
    async uploadLog(logid, qkid, sclx) {
      // let _this = this;
      await axios({
        url: process.env.VUE_APP_SERVER + "/fileprocesser/uploadlog?logid=" + logid + "&blockid=" + qkid + "&sclx=" + sclx,
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          console.log(res);
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    async uploadWithoutFile(param) {
      let _this = this;
      await axios({
        url: process.env.VUE_APP_SERVER + "/fileprocesser/updatetjInfo",
        method: 'POST',
        data: param
      }).then((res) => {
        if (res.status === 200) {
          let resp = res.data;
          _this.uploadLog(param.scLogId, _this.form.qk.length>0?_this.form.qk[_this.form.qk.length-1]:'', param.use);
          console.log("上传文件成功：", resp);
          _this.afterUpload(resp);
        }
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
      })
    },
    handleClose(done) {
      ElMessageBox.confirm('是否确认不做任何操作，关闭当前对话框？')
          .then(() => {
            done()
          })
          .catch(() => {
            // catch error
          })
    },
    fetchQKData() {
      let that = this;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/blockData",
        headers: {
          "Authorization": "Bearer " + jwtSession
        },
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.qkSelOptions = res.data;
          console.log(res);
        }
        // that.loading = false;
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
        // that.loading = false;
      })
    },
    fetchWDLXData() {
      let that = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/businessdata/tjljgxData",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.wdlxSelOptions = res.data;
          console.log(res);
        }
        // that.loading = false;
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
        // that.loading = false;
      })
    },
    qkSelChange(value) {
      let checkedBlock = [];
      console.log(value);
      if (value.length == 0)
        return;
      checkedBlock.push(value[value.length - 1]);
      let that = this;
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellDataByBlk",
        method: 'POST',
        headers: {"Content-Type": "application/json"},
        data: checkedBlock
      }).then((res) => {
        if (res.status === 200) {
          that.welldata = res.data;
          console.log(res);
        }
        // that.loading = false;
      }).catch((err) => {
        ElMessageBox('Error');
        console.log(err)
        // that.loading = false;
      })
    }
  },
  props: {
    uploadUrl: {
      default: process.env.VUE_APP_SERVER + "/fileprocesser/uploadtj"
    },
    shardSize: {//15MB
      default: 15 * 1024 * 1024
    },
    suffixs: {
      default: []
    },
    use: {
      default: "Tj"
    },
    afterUpload: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      inputFile: "",
      fileInfoDlgVisible: false,
      innerVisible: false,
      wdlxSelOptions: [],
      qkSelOptions: [],
      welldata: [],
      form: {
        qk:'',
        lx:'',
        tjr: 'Boris',
        tjsj: new Date(),
        cjr: 'Boris',
        cjsj: new Date(),
        value: '',
        radio1: '1',
      }
    }
  }
}
</script>

<style scoped>

</style>